module.exports = __webpack_public_path__ + "static/media/happy-emoji-svgrepo-com (1).2d280cbe.svg";